import { render, staticRenderFns } from "./ObdDayGraph.vue?vue&type=template&id=b2949cd8&scoped=true&"
import script from "./ObdDayGraph.vue?vue&type=script&lang=js&"
export * from "./ObdDayGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2949cd8",
  null
  
)

export default component.exports